/**
 * Reading the catalogue.
 *
 * A `TemplateSource` over whatever list it is given, so the bundled list and a future KV-backed
 * one are the same object to every caller. The grouping lives here rather than in a client
 * because "which categories have anything in them" is a fact about the catalogue, and two clients
 * deciding it separately is two chances to show an empty shelf.
 */
import { BUNDLED_TEMPLATES } from './bundled';
import { TEMPLATE_CATEGORIES, } from './types';
export function createTemplateSource(templates) {
    const byId = new Map(templates.map((template) => [template.id, template]));
    return {
        all: () => templates,
        byId: (id) => byId.get(id),
    };
}
/** The templates this build ships with. */
export function bundledTemplates() {
    return createTemplateSource(BUNDLED_TEMPLATES);
}
/**
 * Grouped for a browsing UI, in the catalogue's declared category order.
 *
 * Empty categories are left out rather than shown empty: a heading with nothing under it reads as
 * a loading failure, and there is no state here that could be loading.
 */
export function groupByCategory(source) {
    const all = source.all();
    return TEMPLATE_CATEGORIES.map((category) => ({
        category,
        templates: all.filter((template) => template.category === category),
    })).filter((group) => group.templates.length > 0);
}
export function templateById(source, id) {
    return source.byId(id);
}
//# sourceMappingURL=catalog.js.map